import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import NavLinks from '../molecules/NavLinks';
import BlackLogo from "../images/BlackLogo.svg"
import { useLocation } from 'react-router-dom';
import DigitalClock from '../molecules/DigitalClock';


const NavBar: React.FC = () => {
    const location = useLocation();
    const isVitalsBoard = location.pathname === '/vitalsboard';
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleToggle = () => setShow(prev => !prev);

    // Close drawer when route changes
    useEffect(() => {
        setShow(false);
    }, [location.pathname]);

    // Handle click on backdrop to close drawer
    useEffect(() => {
        if (show) {
            const handleBackdropClick = (event: MouseEvent) => {
                const target = event.target as HTMLElement;
                // Check if click is on the backdrop element
                if (target.classList.contains('offcanvas-backdrop')) {
                    handleClose();
                }
            };

            // Small delay to ensure backdrop is rendered
            const timeoutId = setTimeout(() => {
                document.addEventListener('click', handleBackdropClick);
            }, 0);

            return () => {
                clearTimeout(timeoutId);
                document.removeEventListener('click', handleBackdropClick);
            };
        }
    }, [show]);

    return (
        <>
            <Navbar bg="light" expand={false} sticky='top'>
                <Container>
                    <Navbar.Toggle 
                        aria-controls="offcanvas-nav-menu" 
                        onClick={handleToggle}
                    />
                    <Navbar.Brand href="/">
                        <img
                            src={BlackLogo}
                            className="d-inline-block align-top logo"
                            alt="Brisby logo"
                        /></Navbar.Brand>
                    { isVitalsBoard && <DigitalClock backgroundColor='transparent' textColor='#000000' isMilitaryTime /> }
                </Container>
            </Navbar>
            <Offcanvas 
                show={show} 
                onHide={handleClose} 
                placement="start"
                id="offcanvas-nav-menu"
                className="nav-drawer"
                backdrop={true}
            >
                <Offcanvas.Header>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <NavLinks />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default NavBar;
